// xReceived staff with no company of their own (the project account): a slim bar and the staff pages only.
// Company staff see the same pages inside the normal shell, under "xReceived staff".
import { Brand } from '@xr/ui';
import { L, isDark, prefs, toggleLang, toggleTheme } from '../lib/prefs';
import { useRoute } from '../lib/route';
import { signOut, useApp } from '../lib/session';
import { ActivityLogPage } from '../pages/ActivityLog';
import { PlanBuilderPage } from '../pages/PlanBuilder';
import { StaffAccessPage } from '../pages/StaffAccess';
import { AppVersionsPage, CloudReadingPage, IntegrityPage } from '../pages/StaffControls';
import { TestersPage } from '../pages/Testers';
import { Btn, IBtn, Ic } from '../ui/kit';
import { NAV } from './nav';

const STAFF_PAGES: Record<string, () => JSX.Element | null> = { testers: TestersPage, appversions: AppVersionsPage, integrity: IntegrityPage, cloudread: CloudReadingPage, activity: ActivityLogPage, staffaccess: StaffAccessPage, staffplans: PlanBuilderPage };

export function StaffOnly() {
  const { session } = useApp();
  const r = useRoute();
  const route = STAFF_PAGES[r] ? r : 'testers';
  const Page = STAFF_PAGES[route]!;
  const items = NAV.find(g => g.staff)!.items;
  return (
    <div className="staff-only">
      <header className="staff-bar">
        <Brand kind="lockup" h={20} />
        <span className="staff-tag">{L('Staff', 'الفريق')}</span>
        <span className="staff-who">{session?.user.email}</span>
        <IBtn icon="globe" title={prefs.get().lang === 'ar' ? 'English' : 'العربية'} onClick={toggleLang} />
        <IBtn icon={isDark() ? 'sun' : 'moon'} title={isDark() ? L('Light theme', 'الوضع الفاتح') : L('Dark theme', 'الوضع الداكن')} onClick={toggleTheme} />
        <Btn kind="ghost" icon="logout" title={L('Sign out', 'تسجيل الخروج')} onClick={() => void signOut()}>{L('Sign out', 'تسجيل الخروج')}</Btn>
      </header>
      <nav className="staff-nav" aria-label={L('Staff pages', 'صفحات الفريق')}>
        {items.map(([k, icon, en, ar]) => <a key={k} href={'#' + k} aria-current={k === route ? 'page' : undefined}><Ic n={icon} />{L(en, ar)}</a>)}
      </nav>
      <main id="page" className="page" tabIndex={-1}><Page /></main>
    </div>
  );
}
